// extracted by mini-css-extract-plugin
module.exports = {"expenses-filter":"ExpenseFilter_expenses-filter__3Yo7L","expenses-filter__control":"ExpenseFilter_expenses-filter__control__1p9Kf"};